import DashboardLayout from "../DashboardLayout";
import InlineSpinner from "../../../components/loading/InlineSpinner";
import logo from "../../../assets/images/logo-2.png";
import { useRef, useState } from "react";
import { IoPrint } from "react-icons/io5";
import { useFetchData } from "../../../helpers/api";
import Cookies from "js-cookie";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "../../../assets/css/pdf.css";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerId = customerData?.Id ? customerData.Id : null;

const MakingCharges = () => {
  const pdfRef = useRef();
  const [isLoadingPDF, setLoadingPDF] = useState(false);
  const { data: makingChargeData, isLoading } = useFetchData(
    "makingChargeData",
    "/Customer/GetMakingCharge",
    { CustomerId: Number(customerId) }
  );

  const handlePrint = async () => {
    setLoadingPDF(true);
    const input = pdfRef.current;
    if (!input) return;

    try {
      // Clone the content to avoid messing up the UI
      const clonedElement = input.cloneNode(true);
      document.body.appendChild(clonedElement);

      // Apply fixed width only to the cloned version
      clonedElement.style.width = "950px";
      clonedElement.style.transform = "scale(1)";
      clonedElement.style.overflow = "visible";
      clonedElement.style.position = "absolute";
      clonedElement.style.left = "-9999px"; // Hide from view

      // Generate PDF from the cloned element
      const canvas = await html2canvas(clonedElement, {
        scale: 2,
        useCORS: true,
      });
      document.body.removeChild(clonedElement);

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const margin = 10;
      const imgWidth = 210 - margin * 2;

      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
      pdf.save("kalista-making-charges.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setLoadingPDF(false);
    }
  };

  const data =
    makingChargeData?.Data.length > 0 ? makingChargeData.Data[0] : [];

  return (
    <DashboardLayout pageClass="makingCharges_page">
      {isLoading ? (
        <div className="loading_screen">
          <InlineSpinner />
        </div>
      ) : (
        <>
          <div className="print_con">
            <button
              onClick={handlePrint}
              disabled={isLoadingPDF}
              className="button primary_btn print_btn"
            >
              {isLoadingPDF ? (
                <InlineSpinner />
              ) : (
                <>
                  Print <IoPrint size="18px" />
                </>
              )}
            </button>
          </div>
          <div className="dashboard_content" ref={pdfRef}>
            <div className="main_pdf_con">
              <div className="top_logo_con">
                <h1>
                  JOB WORK ORDER POLICY - <span>KS</span>
                </h1>
                <img src={logo} alt="Kalista" className="logo_img" />
              </div>
              <div className="content_con">
                {/* Gold */}
                <h3 className="title">Gold</h3>
                <ul className="list_con">
                  <li>
                    We take an equivalent quantity of gold in advance against
                    confirmation of an order with gold issue voucher only
                  </li>
                  <li>
                    We take gold purity 100% as base purity and the received
                    gold will be converted accordingly.
                  </li>
                </ul>
                <div className="table_con">
                  <table>
                    <thead>
                      <tr>
                        <th>MANUFACTURING / MELTING PURITY(KT.)</th>
                        <th>FINISHED GOODS / BILLING PURITY(KT.)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>14KT - 58.40%</td>
                        <td>59.50%</td>
                      </tr>
                      <tr>
                        <td>18KT - 75.10%</td>
                        <td>76.00%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Diamond */}
                <h3 className="title">Diamond</h3>
                <ul className="list_con">
                  <li>
                    Party has to provide item wise diamond bagging with issue
                    voucher as per our standard procurement process (our sales
                    co-ordinator will explain the same at the time of first
                    order).
                  </li>
                  <li>
                    Approximately 2-3% of Diamond breakage may be bared by the
                    client depending on Quality/ Purity of diamonds
                  </li>
                  <li>
                    In case of Tapper-Buguette breakage % may vary as per the
                    nature & complication involved in the setting work.
                  </li>
                </ul>

                {/* Making Charges */}
                <h3 className="title">Making Charges</h3>
                <ul className="list_con">
                  <li>
                    We charge labour per gram on net gold weight, As below.
                  </li>
                </ul>
                <div className="table_con">
                  <table>
                    <thead>
                      <tr>
                        <th>TYPES OF PRODUCT</th>
                        <th>MAKING</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>All TYPES OF PRODUCT EXCEPT NECKLACE SET</td>
                        <td>{data.AllTypeOfProduct || "625"} /-</td>
                      </tr>
                      <tr>
                        <td>NECKLACE SET</td>
                        <td>{data.NecklaceSet || "675"} /-</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="table_bottom">
                    Minimum labor of 2.0 grams will be charged for the items
                    having wt. below 2.0 grams
                  </div>
                </div>

                {/* Extra Charges */}
                <h3 className="title">Extra Charges</h3>
                <ul className="list_con">
                  <li>
                    Any types of Repairing, Resizing, Refining, Hallmarking,
                    Stamping and other customisation work will be charged extra
                    as per actual.
                  </li>
                </ul>

                {/* Delivery */}
                <h3 className="title">Delivery</h3>
                <ul className="list_con">
                  <li>
                    Customer order within {data.CustomerOrder || "7"} working
                    days.
                  </li>
                  <li>
                    Customer order with customisation within{" "}
                    {data.CustomerOrderCust || "13"} working days
                  </li>
                  <li>
                    Stock order within {data.StockOrder || "13"} working days.
                  </li>
                  <li>
                    Delivery days are counted after receiving gold & diamond.
                  </li>
                </ul>

                {/* Payment */}
                <h3 className="title">Payment</h3>
                <div className="table_con">
                  <table>
                    <thead>
                      <tr>
                        <th>TYPES OF PAYMENT</th>
                        <th>TERMS OF PAYMENT</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Labor Payment</td>
                        <td>Against delivery through bank only</td>
                      </tr>
                      <tr>
                        <td>Parcel Charges</td>
                        <td>
                          {data.ParcelCharges === "Both Side"
                            ? "Both side by the client"
                            : "One side by Client, One side by Us" ||
                            "Both side by the client"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Logistics */}
                <h3 className="title">Logistics</h3>
                <ul className="list_con">
                  <li>
                    As per our experience, for the safe and reliable logistic we
                    strongly recommend
                    <strong> BVC, SEQUEL, RADIANT & AMBE XPRESS </strong>
                    to all our clients, if not then you must provide any three
                    logistic agencies of your choice and we will hand over your
                    parcel to them at your risk during transit.
                  </li>
                </ul>

                {/* bottom */}
                <p className="bottom_para">
                  For any queries please feel free to contact
                  <strong> MR. SAHIL KOSHIA on +91 98679 39900</strong>
                </p>
              </div>
              <div className="bottom_pdf"></div>
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default MakingCharges;
